import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { GlobalWrapper } from './reset.style';
import { DebugPanel } from 'src/domains/layouts/webview/components/debugPanel/DebugPanel';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { EnvironmentState } from 'src/domains/layouts/state/environmentState/EnvironmentState';
import { useEffect } from 'react';
import { SymplifyState } from 'src/domains/layouts/state/symplify/SymplifyState';
import { AppInner } from './uiApp';

export const App = observer('App', () => {
    const common = useCommon();

    const starRouter = StarRouter.get(common);
    const { currentView } = starRouter;

    const env = EnvironmentState.get(common);

    useEffect(() => {
        SymplifyState.get(common).initCarmaRoi();
    }, []);

    return (
        <>
            <GlobalWrapper
                theme={env.emotionTheme}
                currentView={currentView}
            />
            <AppInner />
            <DebugPanel currentView={currentView} />
        </>
    );
});
